export default {
  BUVoucherListRealExpense: 'https://bamboohelp.misa.vn/kb/lap-bang-ke-chung-tu-thanh-toan-thuc-chi/', // Bảng kê thực chi
  DownloadFileDvc: 'https://bamboohelp.misa.vn/knowledge-base/lam-the-nao-khi-khong-xuat-duoc-file-dvc/',
  // Video hướng dẫn sử dụng inbot
  InbotInstructionLink: 'https://www.youtube.com/embed/ugxV6xPoBm0?si=XtqjTQ8UDLAtXgzb',
  UsefulKnowledge: 'https://bambooonline.misa.vn/tinh-nang-moi-bambooonline/?custom=hide',
};
